import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SensorComponent } from './sensor.component';
import { HardwareItemSyncLoadingAnimationModule } from '@caslink/device-client/ng-app/hardware-item-sync-loading-animation/hardware-item-sync-loading-animation.module';
import { ErrorModule } from '@caslink/common-client/ng-app/error/error.module';
import { MonitoringToolbarModule } from '../monitoring-toolbar/monitoring-toolbar.module';
import { MonitoringTreeModule } from '../monitoring-tree/monitoring-tree.module';
import { MonitoringAlertsModule } from '../monitoring-alerts/monitoring-alerts.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MonitoringChartModule } from '../monitoring-chart/monitoring-chart.module';

@NgModule({
    imports: [
        CommonModule,
        ErrorModule,
        HardwareItemSyncLoadingAnimationModule,
        MatTabsModule,
        MonitoringAlertsModule,
        MonitoringToolbarModule,
        MonitoringTreeModule,
        MonitoringChartModule,
    ],
    declarations: [
        SensorComponent,
    ],
    exports: [
        SensorComponent,
    ],
})
export class SensorModule {}
